export enum OMK_SPECIAL_CASE {
  zelao = 'zelao',
  newMoscow = 'newMoscow',
  manualInput = 'manualInput',
}
